import React from "react";
import { Layout } from "antd";

import MainHeader from "../Header/Main";
import { MaintenanceBanner } from "../Maintenance";
import "./Main.scss";

const { Content } = Layout;

const MainLayout = ({ children }) => {
  return (
    <Layout className="MainLayout">
      <MainHeader />
      <Content className="site-layout" style={{ marginTop: 52 }}>
        {/*
          Underhållsbanner: syns för alla inloggade när bannerfönstret är aktivt.
          Ligger INUTI Content — MainHeader är position:fixed med z-index 9999,
          så allt som renderas före Content hamnar bakom headern och blir osynligt.
        */}
        <MaintenanceBanner />
        {children}
      </Content>
    </Layout>
  );
};

export default MainLayout;
